import React, { useRef, useState } from 'react';

export default function CourseForm() {
  const [courseImage, setCourseImage] = useState(null);
  const fileInputRef = useRef();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setCourseImage(file);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      setCourseImage(file);
    }
  };

  return (
    <div className="max-w-7xl mx-auto p-12 bg-zinc-100 ">
      <h1 className="text-3xl font-bold mb-8">Course Details</h1>
      <form className="space-y-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6">
          <div className="space-y-2">
            <label className="block text-sm font-medium">Course Name</label>
            <input type="text" className="w-full border rounded-md p-3" placeholder="Advanced Web Development" />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium">Assign Trainer</label>
            <select className="w-full border rounded-md p-3">
              <option>Select a trainer</option>
            </select>
          </div>

          <div className="md:col-span-2 space-y-2">
            <label className="block text-sm font-medium">Course Description</label>
            <textarea className="w-full border rounded-md p-3" rows="2" placeholder="Short summary of the course" />
          </div>

          <div className="md:col-span-2 space-y-2">
            <label className="block text-sm font-medium">Full Course Description</label>
            <textarea className="w-full border rounded-md p-3" rows="4" placeholder="Detailed course description" />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium">Intro Video URL</label>
            <input type="text" className="w-full border rounded-md p-3" placeholder="https://youtube.com/..." />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium">Course Image</label>
            <div
              className={`w-100 h-40 border-2 border-dashed border-gray-300 rounded-md cursor-pointer transition overflow-hidden ${courseImage ? '' : 'flex flex-col justify-center items-center text-center hover:bg-gray-50'
                }`}
              onClick={() => fileInputRef.current.click()}
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDrop}
            >
              {courseImage ? (
                <img
                  src={URL.createObjectURL(courseImage)}
                  alt="Preview"
                  className="object-cover w-full h-full"
                />
              ) : (
                <>
                  <svg className="w-8 h-8 text-gray-400 mb-2" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M3 15a4 4 0 0 1 4-4h3m4 0h3a4 4 0 1 1 0 8H7a4 4 0 0 1 0-8h1" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 12v9m0 0l-3-3m3 3l3-3" />
                  </svg>
                  <p className="text-gray-600 text-sm">Click or drag file here to upload</p>
                  <p className="text-xs text-gray-400 mt-1">PNG, JPG, JPEG only</p>
                </>
              )}
              <input
                ref={fileInputRef}
                type="file"
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleFileChange}
                className="hidden"
              />
            </div>
          </div>


          <div className="space-y-2">
            <label className="block text-sm font-medium">Start Date</label>
            <input type="date" className="w-full border rounded-md p-3" />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium">Course Duration (Hours)</label>
            <input type="number" className="w-full border rounded-md p-3" placeholder="40" />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium">Difficulty Level</label>
            <select className="w-full border rounded-md p-3">
              <option>Beginner</option>
              <option>Intermediate</option>
              <option>Advanced</option>
            </select>
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium">Category</label>
            <input type="text" className="w-full border rounded-md p-3" placeholder="Technology" />
          </div>

          <div className="space-y-2">
            <label className="block text-sm font-medium">Price ($)</label>
            <input type="text" className="w-full border rounded-md p-3" placeholder="99.99" />
          </div>
        </div>

        <div className="flex items-center gap-4 mt-8">
          <label className="flex items-center gap-2">
            <input type="checkbox" className="form-checkbox" />
            <span className="text-sm">Show on Website</span>
          </label>
        </div>

        <div className="flex justify-end gap-4 mt-8">
          <button type="button" className="px-5 py-2.5 rounded-md border border-gray-300 bg-white hover:bg-gray-100">Save as Draft</button>
          <button type="submit" className="px-5 py-2.5 rounded-md bg-zinc-200 text-black hover:bg-zinc-300">Publish Course</button>
        </div>
      </form>
    </div>
  );
}

